
// import $ from 'jquery'
// import { saveAs } from 'file-saver'
export default {
  name: 'audit-result',
  components: {},
  props: [],
  data () {
    return {
      loading: false,
      date_now: this.$moment(),
      users: null,
      checklist: {},
      summary: {},
      item_reports: [],
      group_checklist_items: [],
      showPageError: false,
      logoReport: '/static/petrolimexaviation.jpg'

    }
  },
  computed: {
    checklist_users () {
      return this.$store.getters['Audit/getUserOfChecklist']
    }
  },
  mounted () {
    this.$loading.start()
    // this.loading = true

    Promise.all([
      this.$store.dispatch('Summary/getResult', {checklist: {id: this.$route.params.checklist_id}})
      // this.$store.dispatch('Audit/getUserOfChecklist', {checklist: {id: this.$route.params.checklist_id}})
    ]).then(res => {
      console.log(res)
      this.checklist = res[0].checklist
      this.summary.self_assessment = res[0].self_assessment
      this.summary.conclusion = res[0].conclusion
      this.group_checklist_items = res[0].chk_items
      // this.users = checklist_users
      this.$loading.complete()
      this.loading = false
    }).catch(errors => {
      if (errors.status === 402) {
        this.showPageError = true
      }
      this.$loading.fail()
      this.loading = false
    })
  },
  methods: {
    print () {
      var innerContents = document.getElementById('page').innerHTML
      var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
      popupWinindow.document.open()
      popupWinindow.document.write('<html><head><link rel="stylesheet" href="/static/bootstrap.css"/><link rel="stylesheet" type="text/css" href="/static/print.css" /><link rel="stylesheet" type="text/css" href="/static/style.css" /></head><body onload="window.print()">' + innerContents + '</html>')
      popupWinindow.document.close()
    },
    word (fileName) {
      var FileSaver = require('file-saver')
      var innerContents = document.getElementById('wordExport').innerHTML
      var blob = new Blob([innerContents], {type: 'application/msword;charset=utf-8'})
      FileSaver.saveAs(blob, this.checklist.name + '.doc')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/view/audit-result/audit-result.js